import { Autocomplete, TextField } from '@mui/material';
import { HorizontalLayoutUI } from './HorizontalLayout';
import { useMemo } from 'react';

export type AutocompleteProps<T> = {
  label: string
  selected: T[]
  options: Array<{ label: string, value: T }>
  onSelect: (value: T[]) => void
  placeHolder?: string
  adornment?: React.ReactElement
};

export type AutocompleteType = <T>(args: AutocompleteProps<T>) => React.ReactElement;
export const AutocompleteUI: AutocompleteType = ({ label, selected, options, onSelect, placeHolder, adornment }) => {
  const selectedOptions = useMemo(() => options.filter(({ value }) => selected.includes(value)), [options, selected]);
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      disablePortal
      limitTags={3}
      options={options}
      getOptionLabel={({ label }) => label}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          size="small"
          placeholder={placeHolder}
          slotProps={adornment
            ? {
                input: {
                  ...params.InputProps,
                  startAdornment: (
                    <HorizontalLayoutUI align="center" wrap="wrap" gap={5}>
                      {adornment}
                      {params.InputProps.startAdornment}
                    </HorizontalLayoutUI>
                  ),
                },
              }
            : undefined}
        />
      )}
      value={selectedOptions}
      onChange={(_, selected) => {
        onSelect(selected.map(({ value }) => value));
      }}
    />
  );
};
